var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('v-img',{attrs:{"src":"https://pbs.twimg.com/profile_images/1202973071604367366/72Ft7ljG.jpg","max-width":"100","contain":"","align":"left"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }